define('casino/providers/Quickspin',['jquery'], function ($) {
    'use strict';


    function Quickspin(casino, gameFunctions) {
        if (!(this instanceof Quickspin)) {
            throw new TypeError('Quickspin constructor cannot be called as a function.');
        }

        this.casino = casino;
        this.gameFunctions = gameFunctions;
    }

    function freeMode(quickspin, game, options) {
        quickspin.gameFunctions.showHelpButton();
        var provider = quickspin.casino.getProvider(game);
        var src = provider.url;

        var splitIdAndCode = game.code.split('_');
        if (splitIdAndCode[0] !== 'QKS') {
            throw new Error('Illegal game code not starting with QKS: ' + game.code);
        }

        var code = splitIdAndCode[1].toLowerCase();

        var baseUrl=src.replace('gamename',code).replace('operator',provider.operator);

        var $gameHolder = options.gameHolder;
        var $game = $gameHolder.find('.game');
        $game.empty();

		baseUrl += $.param({
			lang:provider.locale,
			partnerid:provider.partnerid,
			mode: 'intg',
			moneymode:'fun',
			callback:'',
			clientid:'',
			gameid:game.publishCode
		});

        quickspin.gameFunctions.switchToFreeMode(game, {
            src: baseUrl,
            gameHolder: options.gameHolder,
            type:'iframe'
        });
    }

    function realMode(quickspin, game, options, data) {
        quickspin.gameFunctions.showHelpButton();
        var provider = quickspin.casino.getProvider(game);
        var src = provider.url;

        var splitIdAndCode = game.code.split('_');
        if (splitIdAndCode[0] !== 'QKS') {
            throw new Error('Illegal game code not starting with QKS: ' + game.code);
        }

        var code = splitIdAndCode[1].toLowerCase();

        var baseUrl=src.replace('gamename',code).replace('operator',provider.operator);
        var $gameHolder = options.gameHolder;
        var $game = $gameHolder.find('.game');
        $game.empty();

		baseUrl += $.param({
			lang:provider.locale,
			ticket:game.gameId+'_'+data.sessionId,
			partnerid:provider.partnerid,
			mode: 'intg',
			moneymode:'money',
			callback:'',
			clientid:'',
			gameid:game.publishCode
		});

        quickspin.gameFunctions.switchToRealMode(game, {
            src: baseUrl,
            gameHolder: options.gameHolder,
            type: 'iframe'
        });
        quickspin.gameFunctions.verifyCurrency(data.currency);
    }

    Quickspin.prototype = {
        constructor: Quickspin,
        freeMode: function (game, options) {
            freeMode(this, game, options);
        },
        realMode: function (game, options, data) {
            realMode(this, game, options, data);
        }
    };
    return Quickspin;
});

